import { ResponsiveModalWrapper } from 'src/components/ResponsiveModalWrapper';
import { Content } from './components/Content';
import { Buttons } from './components/Buttons';
import { useModalContext } from 'src/hooks/useModalContext';
import { BonusModalProps } from './types';

export const BonusModal = () => {
  const { modalProps } = useModalContext<BonusModalProps>();
  const bonusData = modalProps?.bonusData;

  return (
    <ResponsiveModalWrapper
      isTransparentBg
      containerClassName="bg-BONUS_MODAL_BG pb-7 flex flex-col items-center max-w-[500px]"
      containerClassNameMobile="bg-BONUS_MODAL_BG rounded-t-[20px] rounded-b-[0] flex flex-col items-center pb-8"
      showCross={false}>
      <Content {...bonusData} />
      <Buttons bonusData={bonusData} />
    </ResponsiveModalWrapper>
  );
};
